module.exports = __webpack_public_path__ + "media/images/icons/utc_emea_logo-eba2e5051d64e9dc6f800b414e56d366.png";